import type { ForwardDealInfo, VanillaOptionDealInfo } from '../../../../types/OTC/otcDealServerTypes';
import { isNonEmpty } from '../../../../utils/string';

/** Display payload for {@link otcStrikeFwdPrice} blotter columns (OTC deal rows and future PM/Risk rows). */
export type OtcStrikeFwdPriceValue =
  | { type: 'number'; value?: string; currency?: string; increment?: string }
  | { type: 'text'; value?: string };

export function getOtcStrikeFwdPriceValueFromForwardDealInfo(
  dealInfo: ForwardDealInfo,
  quoteAsset?: string
): OtcStrikeFwdPriceValue | undefined {
  const value = dealInfo.ForwardPrice;
  if (!isNonEmpty(value)) {
    return undefined;
  }
  return {
    type: 'number',
    value,
    currency: isNonEmpty(quoteAsset) ? quoteAsset : dealInfo.forwardPriceCurrency,
  };
}

/**
 * Strike from deal as a formatted number + display currency; otherwise delta as plain text (`{delta}D`).
 * Currency: deal `StrikePriceCcy`, else product template `StrikePriceCcy`, else `USD`.
 */
export function getOtcStrikeFwdPriceValueFromVanillaOptionDealInfo(
  dealInfo: VanillaOptionDealInfo,
  productStrikePriceCcy?: string
): OtcStrikeFwdPriceValue | undefined {
  const strike = dealInfo.StrikePrice;
  if (isNonEmpty(strike)) {
    const currency = dealInfo.StrikePriceCcy?.trim() || productStrikePriceCcy?.trim() || 'USD';
    return { type: 'number', value: strike, currency };
  }
  const delta = dealInfo.StrikeDelta;
  if (isNonEmpty(delta)) {
    return { type: 'text', value: `${String(delta).trim()}D` };
  }
  return undefined;
}
